import React from "react";

const LeftArrow = (props) => (
  <svg viewBox="0 0 100 100" {...props}>
    <path d="M54.13 10.056L47.231 3 0 50.41l47.231 47.174 6.9-7.013-35.373-35.443 81.242.337v-9.943H18.758" />
  </svg>
);

export default LeftArrow;
